import React from 'react';
import { Link } from 'react-router-dom';
import StaticPage from '../../static/StaticPage';
import styles from '../../static/staticPage.module.css';

const TermsOfServicePage = () => {
  return (
    <StaticPage
      title="Terms of Service"
      subtitle="Last updated: March 31, 2026. By using BarberShop, you agree to these terms."
    >
      <section className={styles.section}>
        <h2>Acceptance</h2>
        <p>
          These Terms govern your access to and use of our website, apps, and related services
          (“Services”). If you do not agree, do not use the Services.
        </p>
      </section>
      <section className={styles.section}>
        <h2>Accounts</h2>
        <p>
          You must provide accurate information and keep your credentials confidential. You are
          responsible for activity under your account. We may suspend or terminate accounts that
          violate these Terms or applicable law.
        </p>
      </section>
      <section className={styles.section}>
        <h2>Bookings &amp; marketplace</h2>
        <p>
          BarberShop facilitates connections between you and independent salons or vendors. Service
          quality, timing, and pricing for in-salon work are primarily the responsibility of the
          partner you book with, subject to our policies and any guarantees we expressly state at
          checkout.
        </p>
      </section>
      <section className={styles.section}>
        <h2>Payments</h2>
        <p>
          Payments may be processed by third-party providers. By paying through the platform, you
          agree to their terms as well as ours. Taxes and fees may apply as shown before you confirm
          payment.
        </p>
      </section>
      <section className={styles.section}>
        <h2>Prohibited use</h2>
        <ul>
          <li>Violating laws or third-party rights</li>
          <li>Attempting to scrape, hack, or overload our systems</li>
          <li>Posting false, misleading, or abusive content</li>
          <li>Circumventing fees owed to partners or the platform</li>
        </ul>
      </section>
      <section className={styles.section}>
        <h2>Disclaimer</h2>
        <p>
          The Services are provided “as is” to the fullest extent permitted by law. We disclaim
          implied warranties where allowed. Our liability is limited as described in our Refund
          Policy and mandatory consumer protections in your jurisdiction may apply.
        </p>
      </section>
      <section className={styles.section}>
        <h2>Governing law</h2>
        <p>
          These Terms are governed by the laws of India, unless otherwise required by your place of
          residence. Courts in Noida, Uttar Pradesh (Gautam Buddha Nagar) shall have exclusive
          jurisdiction, where permitted.
        </p>
      </section>
      <section className={styles.section}>
        <h2>Contact</h2>
        <p>
          Legal questions: use the <Link to="/contact">contact form</Link> or email{' '}
          <a href="mailto:info@timetofuture.com">info@timetofuture.com</a>.
        </p>
      </section>
    </StaticPage>
  );
};

export default TermsOfServicePage;
